import  firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import { monthNames, dayNames } from '../constants';




const firebaseConfig = {
  apiKey: "AIzaSyClxFQwQiQo-6VnuHklysPgEL5-zpa8y0g",
  authDomain: "mass-reserve-1.firebaseapp.com",
  databaseURL: "https://mass-reserve-1.firebaseio.com",
  projectId: "mass-reserve-1",
  storageBucket: "mass-reserve-1.appspot.com",
  messagingSenderId: "122150331688",
  appId: "1:122150331688:web:039808b14769c286625c1d"
};

firebase.initializeApp(firebaseConfig);


/***********************************************************************
 * UTILITY ROUTINES FOR MANAGING THE USER DATABASE IN THE CLOUD
 ************************************************************************/

export const auth = firebase.auth();
export const firestore = firebase.firestore();

export const createUserProfileDocument = async (userAuth, additionalData) => {
  if (!userAuth) return;
  
  const userRef = firestore.doc(`users/${userAuth.uid}`);
  const snapShot = await userRef.get();

  if (!snapShot.exists) {
    const { email } = userAuth;
    const createdAt = new Date();

    try {
      await userRef.set({
        email,
        createdAt,
        ...additionalData
      });
    } catch (error) {
        console.log('Error creating user', error.message);
    }
  }

  return userRef;

};

export const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(userAuth => { 
      unsubscribe();
      resolve(userAuth);
      }, reject)
    });
  };



/***********************************************************************
 * UTILITY ROUTINES FOR MANAGING THE RESERVATION DATABASE IN THE CLOUD
 ************************************************************************/

/* Add the new reservation to the cloud. */

export const addReservationToCloud = async (id, reservation) => {

  const db = firebase.firestore();
  db.collection("reservations").doc(id).set(reservation)
      .then(() => {
        console.log("Success");
      })
      .catch((error) => {
        console.log("Failure", error);
      });
};

/* Delete the specified reservation from the cloud. */ 

export const deleteReservationFromCloud = async (cloudId) => {
  const db = firebase.firestore();
  db.collection("reservations").doc(cloudId).delete()
    .then(() => {
      console.log("Deleted Reservation");
    }).catch((error) => {
      console.log("Error removing document: ", error);
    });
};
  




 /***********************************************************************
 * UTILITY ROUTINES FOR MANAGING THE MASS DATABASE IN THE CLOUD
 ************************************************************************/

export const incrementMassReservations = async (massId, seats, sections, addFlag) => {

  /* Modify the "seatsReserved" and "sectionsReserved" fields of the mass object in 
  the cloud by the specified amounts. If the "addFlag is true, then the values are
  added to the mass object. If the "addFlag" is false, they are subtracted.
  */

 let increment;

 const db = firebase.firestore();
 const documentRef = db.collection('masses').doc(massId);
  
  /* If addFlag is true, then increment the sectionsReserved value (first) and 
     the seatsReserved value (second) in the cloud database by the amounts specified */

 

  if (addFlag) {
      
      increment = firebase.firestore.FieldValue.increment(sections);
      
      try {
        await documentRef.update({ sectionsReserved : increment });
      } catch (error) {
          console.log('Error incrementing sectionsReserved field', error.message);
      } 

      increment = firebase.firestore.FieldValue.increment(seats);

      try {
        await documentRef.update({ seatsReserved : increment });
      } catch (error) {
          console.log('Error incrementing seatsReserved field', error.message);
      }

  /* Otherwise, decrement the seatsReserved value (first) and then the 
     sectionsReserved value (second) in the cloud database by the amounts specified. */
  } else {

      increment = firebase.firestore.FieldValue.increment(-seats);
      
      try {
        await documentRef.update({ seatsReserved : increment });
      } catch (error) {
          console.log('Error incrementing sectionsReserved field', error.message);
      }

     increment = firebase.firestore.FieldValue.increment(-sections);

      try {
        await documentRef.update({ sectionsReserved : increment });
      } catch (error) {
          console.log('Error incrementing seatsReserved field', error.message);
      } 

  }

};

/* This routine is used to reset the times and reserve counts in the Mass Database.
  The update list is an array of object, one per Mass which looks like this:
  { massId, massTimeDate, openTimeDate, currentReserved */
    
export const resetMassDatabase = updateList => {

  let batch = firestore.batch();
  let massRef = null;

  updateList.forEach( update => {
    const { massId, massTimeDate, openTimeDate, currentReserved } = update;
    //console.log(massId, massTimeDate, openTimeDate, currentReserved);
    const massTime = firebase.firestore.Timestamp.fromDate(massTimeDate);
    const openTime = firebase.firestore.Timestamp.fromDate(openTimeDate);

    massRef = firestore.collection("masses").doc(massId);
    batch.update(massRef, {"currentReserved" : currentReserved, "massTime" : massTime, "openForReservations" : openTime  });
  });

  batch.commit().then(() => {
    console.log("Successful Update");
  }).catch((error) => {
    console.log("Update failed: ", error);
  });

}
/*This routine converts the Firebase Mass objects into the type we want to use
 in the program by flattening it and converting the timestamp to a Date.
 */

export const convertTypesSnapshotToArray = (snapshot) => {

  let tempObject1 = {};
  let tempObject2 = {};
  let tempObject3 = {};

  const transformedCollection = snapshot.docs.map(doc => {
    
    //We need to pull massTime and openForReservations which are timestamps out of the data and convert it to Date,
    //then flatten the entire object
    tempObject1 = doc.data();
    console.log("snapshot data: ", tempObject1);
    tempObject2 = tempObject1.openForReservations.toDate();
    delete tempObject1.openForReservations;
   
    tempObject3 = flattenObject(tempObject1);

    return {type: doc.id,  openTimeDate: tempObject2, ...tempObject3, }; 

  });
    /* Second sort the array by timestamp*/

  console.log("the TC ", transformedCollection);

  return transformedCollection;
};
  

/*This routine converts the Firebase Mass objects into the type we want to use
 in the program by flattening it and converting the timestamp to a Date.
 */

export const convertMassesSnapshotToArray = (snapshot, typesArray) => {

  let tempObject1 = {};
  let tempObject2 = {};
  let tempOjbect3 = {};
  let tempObject4 = {};

  const transformedCollection = snapshot.docs.map(doc => {

    
    //We need to 1) fetch the type of mass so its info can be added to the final mass object,
    // pull massTime timestamps out of the data and convert it to Date,
    //then flatten the entire object,
    //and add some useful fields

    tempObject1 = doc.data();

    // Get the type info for this mass

    const index = typesArray.findIndex( el => el.type === tempObject1.type);
    const massType = typesArray[index];

    delete tempObject1.type;

    // Extract the massTime Timestamp and convert it to a javascript time value

    tempObject2 = tempObject1.massTime.toDate();
    delete tempObject1.massTime;

    // Extract the openForReservations Timestamp and convert it to a javascript time value

    tempOjbect3 = tempObject1.openForReservations.toDate();
    delete tempObject1.openForReservations;
   
    tempObject4 = flattenObject(tempObject1);
    
    /*Now add useful derived fields for the final mass object */
    //Name is the day and date of the Mass
    const name = `${dayNames[tempObject2.getDay()]},  ${monthNames[tempObject2.getMonth()]} ${tempObject2.getDate()}, ${tempObject2.getFullYear()}`;

    //These represent the number of seats and sections available
    const availSeats = Math.max((massType.maxSeats - tempObject4.seatsReserved), 0);
    const availSections = Math.max((massType.maxSections - tempObject4.sectionsReserved) , 0);

    //Get a string that gives the time with no trailing zeros

    let localTime = tempObject2.toLocaleTimeString();
    let tempStr = localTime.split(":");
    tempStr = (tempStr[1] !== '00') ? `:${tempStr[1]}` : "";
    localTime = `${localTime.substring(0, localTime.indexOf(":"))}${tempStr} ${localTime.slice(-2)}`;

    /*Now return the new mass object */ 

    return {name: name, availSeats: availSeats, availSections: availSections, 
            localTime: localTime, massId: doc.id,  massTimeDate: tempObject2, openTimeDate: tempOjbect3, 
            ...tempObject4, ...massType}; 

  });
    /* Second sort the array by timestamp*/
  
  transformedCollection.sort((a,b) => (a.massTimeDate > b.massTimeDate) ? 1 : -1);

  return transformedCollection;
};



/***********************************************************************
 * UTILITY ROUTINES 
 ************************************************************************/
 
/*Helper routine for convertMassesSnapshotToArray Function
*/

const flattenObject = (ob) => {
	let toReturn = {};
	
	for (let i in ob) {
		if (!ob.hasOwnProperty(i)) continue;
		
		if ((typeof ob[i]) == 'object') {
			var flatObject = flattenObject(ob[i]);
			for (var x in flatObject) {
				if (!flatObject.hasOwnProperty(x)) continue;
				
				toReturn[x] = flatObject[x];
			}
		} else {
			toReturn[i] = ob[i];
		}
	}
	return toReturn;
};







/* This utility was used to upload the original Mass data for this project
into the cloud 
*/

export const addCollectionAndDocuments = async (collectionKey, objectsToAdd) => {
  //First step is create a new collection in firestore named collectionKey

const collectionRef = firestore.collection(collectionKey);

  //Do the following upload in a batch so that new collection is not 
  //corrupted if there is a failure in the upload process.
const batch = firestore.batch();
  //step through each of the objects to upload and 
  //make each a new document in the created collection.
objectsToAdd.forEach(obj => {
  const newDocRef = collectionRef.doc();
  batch.set(newDocRef, obj);
});

return await batch.commit()
};


export default firebase;